export default {
  GET_LATEST_WATER_LEVEL: 'GET_LATEST_WATER_LEVEL',
  GET_HOURLY_RIVER_LEVEL: 'GET_HOURLY_RIVER_LEVEL',
  GET_RESERVOIR_IMPOUNDMENT_INFO: 'GET_RESERVOIR_IMPOUNDMENT_INFO',
  GET_OVERFLOW_WARNING_RAIN: 'GET_OVERFLOW_WARNING_RAIN',
  GET_OVERFLOW_WARNING_WATER: 'GET_OVERFLOW_WARNING_WATER'
}
